import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-navy py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-73" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-74" data-mp="9tbbwq28ocf4">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-electric/70 bg-industrial p-8 shadow-glow sm:p-12" data-id="element-75" data-mp="etfx2te3dvbo">
          <span className="inline-flex rounded-full bg-gold p-4 text-navy shadow-glow-gold" data-id="element-76" data-mp="sm5jgyxj929b">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-77" data-mp="xivzjm9c7xuq" />
          </span>
          <h2 id="guarantee-title" className="mt-6 font-display text-4xl font-extrabold uppercase tracking-tight text-silver sm:text-5xl" data-id="element-78" data-mp="12jtgjvim2lun">
            7-Day Guarantee
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-steel" data-id="element-79" data-mp="25rnl1588kwvx">
            Study all 6 volumes and 5 bonuses in your specific mechanical engineering focus area this week. If the
            technical depth doesn't match your professional needs or materials don't enhance your capability,{' '}
            <span className="font-extrabold text-gold" data-id="element-80" data-mp="1rsfh5z14p0le">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}